import moment from 'moment';

export const calculateAge = (
  dateString: string,
  dateFormat: string = 'DD MMM YY',
) => {
  const birthDate = moment(dateString, moment.ISO_8601, true).isValid()
    ? moment(dateString) // Parse as ISO
    : moment(dateString, dateFormat); // Parse as custom format

  if (!birthDate.isValid()) {
    return null;
  }

  const age = moment().diff(birthDate, 'years');
  return age;
};
